import { LOGOUT_USER_ACCOUNT } from "store/actions/Auth";
import { createReducer } from "./Util";
import {
  CREATE_PERSON,
  DELETE_PERSON,
  GET_CUSTOMER_PERSONS,
  GET_PERSONS,
  GET_PERSON,
  LINK_PERSON_TO_CUSTOMER,
  UPDATE_PERSON
} from "store/actions/Customers";
import { Person } from "../../models/Person";

export class PersonsState {

  private persons: { [index: string]: Person }

  constructor() {
    this.persons = {}
  }

  public setPersons(persons: Person[]) {
    persons.forEach(person => {
      this.setPerson(person)
    })
    return this
  }

  public setPerson(person: Person) {
    this.persons[person.id] = person
    return this
  }
  public deletePerson(id: number) {
    delete this.persons[id];
    return this
  }

  public getPersonById(id: string): Person | null {
    return this.persons[id] ?? null
  }
  public getPersonByPhone(phone: string): Person | null {
    return Object.values(this.persons).find(person => person.phone === phone) ?? null
  }

  public getPersonsByCustomerId(id: string): Person[] {
    return this.getPersons().filter(person => person.customers.indexOf(id) > -1)
  }

  public getPersons(): Person[] {
    return Object.values(this.persons)
  }

}

const Persons = createReducer<PersonsState>(new PersonsState())
  .handle<Person[]>([GET_PERSONS.SUCCESS, GET_CUSTOMER_PERSONS.SUCCESS], (state, payload) => state.setPersons(payload))
  .handle<Person>([GET_PERSON.SUCCESS, LINK_PERSON_TO_CUSTOMER.SUCCESS, CREATE_PERSON.SUCCESS, UPDATE_PERSON.SUCCESS], (state, payload) => state.setPerson(payload))
  .handle<number>([DELETE_PERSON.SUCCESS], (state, payload) => state.deletePerson(payload))
  .handle([LOGOUT_USER_ACCOUNT.SUCCESS], () => new PersonsState());

export default Persons.handler;
